var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0a1227;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.78.57l2.64,2.61a1.91,1.91,0,0,1,.41.64,1.92,1.92,0,0,1,.17.73V14.2a.78.78,0,0,1-.24.57.79.79,0,0,1-.57.23H.81a.79.79,0,0,1-.57-.23A.78.78,0,0,1,0,14.2V.8A.78.78,0,0,1,.24.23.79.79,0,0,1,.81,0H8.4a2,2,0,0,1,.74.17A1.8,1.8,0,0,1,9.78.57ZM9,1.32a.87.87,0,0,0-.34-.18V4.29h3.18a.92.92,0,0,0-.19-.35ZM1,14H11.92V5.36H8.4a.78.78,0,0,1-.58-.24.75.75,0,0,1-.24-.57V1.07H1ZM3.25,7.23V6.7a.28.28,0,0,1,.08-.2.25.25,0,0,1,.19-.07h6a.25.25,0,0,1,.19.07.28.28,0,0,1,.08.2v.53a.27.27,0,0,1-.27.27h-6a.27.27,0,0,1-.27-.27Zm.27,1.34h6a.27.27,0,0,1,.27.27v.54a.27.27,0,0,1-.08.19.25.25,0,0,1-.19.07h-6a.25.25,0,0,1-.19-.07.27.27,0,0,1-.08-.19V8.84a.27.27,0,0,1,.27-.27Zm0,2.14h6a.27.27,0,0,1,.27.27v.54a.27.27,0,0,1-.27.27h-6a.27.27,0,0,1-.27-.27V11a.27.27,0,0,1,.27-.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.31101acad5462043b36ff9ba84e4e2ca.svg";
export { ForwardRef as ReactComponent };